import { Action, createFeatureSelector, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { TaskTimerHistory } from '../../../data-services/task-timer/task-timer.model';
import * as TaskTimerHistoryActions from './task-timer-history.actions';

export const TaskTimerHistorysFeatureKey = 'TaskTimerHistorys';

export interface State extends EntityState<TaskTimerHistory> {
    // additional entities state properties
}

export const adapter: EntityAdapter<any> =
    createEntityAdapter<TaskTimerHistory>({
        selectId: (model: TaskTimerHistory) =>
            `${model.empauthid}-${model.timerid}`
    });

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

export const TaskTimerHistoryReducer = createReducer(
    initialState,
    on(TaskTimerHistoryActions.addTaskTimerHistory, (state, action) =>
        adapter.addOne(action.TaskTimerHistory, state)
    ),
    on(TaskTimerHistoryActions.upsertTaskTimerHistory, (state, action) =>
        adapter.upsertOne(action.TaskTimerHistory, state)
    ),
    on(TaskTimerHistoryActions.addTaskTimerHistorys, (state, action) =>
        adapter.addMany(action.TaskTimerHistorys, state)
    ),
    on(TaskTimerHistoryActions.upsertTaskTimerHistorys, (state, action) =>
        adapter.upsertMany(action.TaskTimerHistorys, state)
    ),
    on(TaskTimerHistoryActions.updateTaskTimerHistory, (state, action) =>
        adapter.updateOne(action.TaskTimerHistory, state)
    ),
    on(TaskTimerHistoryActions.updateTaskTimerHistorys, (state, action) =>
        adapter.updateMany(action.TaskTimerHistorys, state)
    ),
    on(TaskTimerHistoryActions.deleteTaskTimerHistory, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(TaskTimerHistoryActions.deleteTaskTimerHistorys, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(TaskTimerHistoryActions.loadTaskTimerHistorys, (state, action) =>
        adapter.setAll(action.TaskTimerHistorys, state)
    ),
    on(TaskTimerHistoryActions.clearTaskTimerHistorys, state =>
        adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return TaskTimerHistoryReducer(state, action);
}

export const selectTaskTimerHistoryState = createFeatureSelector<State>(
    TaskTimerHistorysFeatureKey
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
    adapter.getSelectors(selectTaskTimerHistoryState);
